import { GoBack } from "@/components/shared/layout"
import privacyConfig from "@/features/static/components/privacy-config.json"

interface PrivacySection {
  id: string
  title: string
  isExpanded: boolean
  content: string[]
}

interface PrivacyConfig {
  title: string
  sections: PrivacySection[]
}

const PrivacyPage = () => {
  const config = privacyConfig as PrivacyConfig
  const searchParams = new URLSearchParams(window.location.search)
  const isViewMode = searchParams.get("mode") === "view"

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      {!isViewMode && (
        <div className="sticky top-0 z-50">
          <GoBack title={config.title} className="bg-white" />
        </div>
      )}

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        {/* Header */}
        <div className="text-center mb-10 border-b pb-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary text-center mb-2 leading-tight">
            CHÍNH SÁCH BẢO VỆ THÔNG TIN CÁ NHÂN
          </h2>
          <p className="text-gray-500 italic font-medium">
            Chính Sách này có hiệu lực kể từ ngày 01 tháng 11 năm 2025.
          </p>
        </div>

        {/* Section 1 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">1. GIỚI THIỆU</h2>
          <p>
            1.1. <strong>CÔNG TY CỔ PHẦN ALPHA SPACEZ </strong>và các bên liên kết của CÔNG TY CỔ
            PHẦN ALPHA SPACEZ (được gọi riêng là “<strong>ALPHA SPACEZ</strong>” hoặc gọi chung là “
            <strong>Chúng Tôi</strong>
            ”) rất tôn trọng quyền riêng tư của Bạn – người dùng trên ứng dụng ZZP (“
            <strong>Ứng Dụng</strong>”). Tại Việt Nam, pháp nhân kiểm soát dữ liệu cá nhân của Bạn
            là <strong>CÔNG TY CỔ PHẦN ALPHA SPACEZ </strong>(tên tiếng Anh:{" "}
            <strong>ALPHA SPACEZ JOINT STOCK</strong>) – chủ sở hữu của Ứng Dụng.
          </p>
          <p>
            1.2. Trong quá trình cung cấp cho Bạn các Dịch Vụ hoặc quyền truy cập vào Ứng Dụng (như
            được định nghĩa trong Điều Khoản Sử Dụng), Chúng Tôi sẽ thu thập, sử dụng, tiết lộ, lưu
            trữ và/hoặc xử lý dữ liệu, bao gồm cả dữ liệu cá nhân của Bạn.
          </p>
          <p>
            1.3. Chính Sách Bảo Vệ Thông Tin Cá Nhân này (“Chính Sách”) thiết lập để giúp Bạn biết
            được cách thức Chúng Tôi thu thập, sử dụng, tiết lộ, lưu trữ và/hoặc xử lý dữ liệu mà
            Chúng Tôi thu thập và nhận được trong quá trình Bạn truy cập và thực hiện các thao tác,
            giao dịch trên Ứng Dụng. Chúng Tôi sẽ chỉ thu thập, sử dụng, tiết lộ, lưu trữ và/hoặc xử
            lý dữ liệu cá nhân của Bạn theo Chính Sách này.
          </p>
          <p>
            1.4. Bạn cần đọc Chính Sách này cùng với bất kỳ thông báo được áp dụng nào khác mà Chúng
            Tôi có thể đưa ra trong các trường hợp cụ thể khi Chúng Tôi thu thập, sử dụng, tiết lộ
            và/hoặc xử lý dữ liệu cá nhân về Bạn, đảm bảo Bạn nhận thức đầy đủ về cách thức và lý do
            Chúng Tôi sử dụng dữ liệu cá nhân của Bạn.
          </p>
          <p>
            1.5. Chúng Tôi có thể cập nhật Chính Sách này theo từng thời điểm. Bất kỳ thay đổi nào
            được Chúng Tôi thực hiện đối với Chính Sách này trong tương lai sẽ được phản ánh trên
            Ứng Dụng và những thay đổi quan trọng sẽ được thông báo cho Bạn. Việc Bạn tiếp tục sử
            dụng và giao dịch trên Ứng Dụng, hoặc đồng ý rõ ràng đối với điều đó, sẽ cấu thành sự
            xác nhận và chấp thuận của Bạn về những thay đổi mà Chúng Tôi thực hiện đối với Chính
            Sách này. Bạn đồng ý rằng Bạn có trách nhiệm kiểm tra lại thường xuyên để biết bất kỳ
            cập nhật hoặc thay đổi nào đối với Chính Sách này.
          </p>
          <p>
            1.6. Chính Sách này được áp dụng cùng với các thông báo, điều khoản hợp đồng và điều
            khoản chấp thuận khác được áp dụng liên quan đến việc Chúng Tôi thu thập, lưu trữ, sử
            dụng, tiết lộ và/hoặc xử lý dữ liệu cá nhân của Bạn và không nhằm mục đích thay thế các
            thông báo, điều khoản hợp đồng và điều khoản chấp thuận đó, trừ khi được Chúng Tôi tuyên
            bố khác đi một cách rõ ràng.
          </p>
          <p>1.7. Tất cả các điều khoản này được áp dụng cho toàn bộ người dùng trên Ứng Dụng.</p>
        </section>

        {/* Section 2 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            2. DỮ LIỆU CÁ NHÂN CHÚNG TÔI THU THẬP TỪ BẠN
          </h2>
          <p>
            2.1. Dữ liệu cá nhân có nghĩa là bất kỳ thông tin nào về một cá nhân, cho dù được ghi
            lại ở dạng vật chất hay không và có đúng sự thật hay không, mà có thể xác định được danh
            tính của cá nhân từ dữ liệu đó (dù trực tiếp hay gián tiếp), hoặc từ dữ liệu đó kết hợp
            cùng với dữ liệu khác mà Chúng Tôi có được hoặc có thể truy cập được.
          </p>
          <p>
            2.2. Trong quá trình Bạn sử dụng Ứng Dụng, Chúng Tôi có thể thu thập dữ liệu cá nhân của
            Bạn như sau:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (i) Dữ liệu định danh, chẳng hạn như là tên, giới tính, hình ảnh cá nhân, và ngày
              tháng năm sinh;
            </p>
            <p>
              (ii) Dữ liệu liên lạc, chẳng hạn như địa chỉ xuất hóa đơn, địa chỉ giao hàng, địa chỉ
              thư điện tử và số điện thoại;
            </p>
            <p>
              (iii) Dữ liệu sinh trắc học, chẳng hạn như tập tin ghi âm giọng nói khi Bạn sử dụng
              chức năng tìm kiếm bằng giọng nói của Chúng Tôi, và các đặc điểm khuôn mặt và đặc điểm
              cơ thể khác và giọng nói của chính Bạn và/hoặc những người khác có trong video của Bạn
              khi Bạn tải video lên;
            </p>
            <p>
              (iv) Dữ liệu tài khoản, chẳng hạn như chi tiết tài khoản ngân hàng, sao kê tài khoản,
              thông tin thẻ tín dụng và thông tin thanh toán (những dữ liệu tài khoản này có thể
              được thu thập trực tiếp bởi các bên liên kết và/hoặc bên thứ ba cung cấp dịch vụ thanh
              toán);
            </p>
            <p>
              (v) Dữ liệu giao dịch, chẳng hạn như thông tin về đơn đặt hàng và thanh toán, và các
              thông tin khác của sản phẩm và các dịch vụ liên quan đến Bạn;
            </p>
            <p>
              (vi) Dữ liệu kỹ thuật, chẳng hạn như địa chỉ giao thức Internet (IP), dữ liệu đăng
              nhập của Bạn, loại và phiên bản trình duyệt, cài đặt múi giờ và địa điểm, các loại và
              phiên bản của phần mềm bổ trợ (plug-in) trình duyệt, hệ điều hành và Ứng Dụng, nhận
              dạng thiết bị di động quốc tế, mã định danh thiết bị, IMEI, địa chỉ MAC, cookies (nếu
              được áp dụng) và các thông tin và công nghệ khác trên thiết bị mà Bạn sử dụng để truy
              cập Ứng Dụng;
            </p>
            <p>
              (vii) Dữ liệu hồ sơ, chẳng hạn như tên người dùng và mật khẩu của Bạn, đơn đặt hàng
              liên quan đến Bạn, sở thích, lựa chọn ưu tiên, phản ánh và phản hồi khảo sát của Bạn;
            </p>
            <p>
              (viii) Dữ liệu sử dụng, chẳng hạn như thông tin về cách thức Bạn sử dụng Ứng Dụng, xem
              thông tin sản phẩm và các dịch vụ hoặc xem bất kỳ nội dung nào trên Ứng Dụng, bao gồm
              thời gian truy cập Ứng Dụng, các mục và dữ liệu được tìm kiếm trên Ứng Dụng, bao gồm
              số lần và ngày truy cập, cũng như các trang web Bạn đã truy cập trước khi truy cập vào
              Ứng Dụng và các số liệu thống kê tương tự khác;
            </p>
            <p>
              (ix) Dữ liệu vị trí, chẳng hạn như khi Bạn chụp và chia sẻ vị trí của mình với Chúng
              Tôi dưới dạng ảnh hoặc video và đăng tải nội dung đó lên Ứng Dụng;
            </p>
            <p>
              (x) Dữ liệu tiếp thị và truyền thông, chẳng hạn như sự ưu tiên của Bạn khi tiếp nhận
              thông tin tiếp thị, quảng cáo từ Chúng Tôi và các bên thứ ba của Chúng Tôi và các ưu
              tiên về trao đổi thông tin của Bạn và cuộc trò chuyện, thư điện tử và lịch sử cuộc gọi
              của Bạn trên Ứng Dụng hoặc với bên thứ ba cung cấp dịch vụ khách hàng; và
            </p>
            <p>
              (xi) Thông tin bổ sung Chúng Tôi có thể yêu cầu Bạn cung cấp tài liệu để thẩm định
              nhận dạng (chẳng hạn như bản sao giấy tờ tùy thân như hộ chiếu, chứng minh nhân dân do
              cơ quan chức năng cấp) hoặc nếu Chúng Tôi tin rằng Bạn đang vi phạm Chính Sách hoặc
              Điều Khoản Sử Dụng của Chúng Tôi.
            </p>
          </div>

          <p>
            2.3. Trong quá trình Bạn sử dụng Ứng Dụng, Chúng Tôi có thể tiếp nhận dữ liệu cá nhân
            của Bạn trong các trường hợp như sau:
          </p>
          <div className="pl-4 md:pl-8 grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 text-gray-700">
            <p>(a) Khi Bạn truy cập Ứng Dụng của Chúng Tôi;</p>
            <p>
              (b) Khi Bạn tạo tài khoản trên Ứng Dụng của Chúng Tôi (với tư cách là người dùng);
            </p>
            <p>
              (d) Khi Bạn đăng ký sử dụng, hoặc yêu cầu sử dụng bất kỳ dịch vụ nào được cung ứng
              trên Ứng Dụng;
            </p>
            <p>
              (e) Khi Bạn thực hiện một giao dịch liên quan đến những dịch vụ Chúng Tôi cung cấp
              trên Ứng Dụng;
            </p>
            <p>
              (f) Khi Bạn kích hoạt hoặc sử dụng các chức năng liên quan đến thanh toán có sẵn trên
              Ứng Dụng hoặc được cung cấp bởi bên cung cấp dịch vụ thứ ba;
            </p>
            <p>
              (h) Khi Bạn ghi lại bất kỳ nội dung nào do người dùng tạo ra và đăng tải lên Ứng Dụng;
            </p>
            <p>(i) Khi Bạn sử dụng chức năng trò chuyện trên Ứng Dụng;</p>
            <p>(j) Khi Bạn đăng ký nhận các ấn phẩm của Chúng Tôi hoặc công cụ hỗ trợ tiếp thị;</p>
            <p>(k) Khi Bạn tham gia một cuộc thi, chương trình khuyến mại hoặc khảo sát;</p>
            <p>(l) Khi Bạn tham gia vào bất kỳ hoạt động hoặc chiến dịch nào trên Ứng Dụng;</p>
            <p>
              (m) Khi Bạn đăng nhập vào tài khoản của mình trên Ứng Dụng hoặc tương tác với Chúng
              Tôi thông qua dịch vụ hoặc ứng dụng khác, chẳng hạn như Facebook hoặc Google có liên
              kết với Ứng Dụng;
            </p>
            <p>
              (n) Khi bất kỳ người dùng nào khác trên Ứng Dụng đăng bất kỳ nhận xét nào về nội dung
              Bạn đã tải lên trên Ứng Dụng hoặc khi Bạn đăng bất kỳ nhận xét nào về nội dung của
              người dùng khác đã tải lên Ứng Dụng;
            </p>
            <p>(o) Khi bên thứ ba khiếu nại Bạn hoặc nội dung Bạn đã đăng trên Ứng Dụng; và</p>
            <p>
              (p) Khi Bạn tương tác với Chúng Tôi trực tiếp, kể cả khi Bạn tương tác với các đại lý
              dịch vụ khách hàng được thuê ngoài của Chúng Tôi (nếu có).
            </p>
          </div>

          <p>
            2.4. Chúng Tôi có thể thu thập dữ liệu cá nhân từ Bạn, các bên thứ ba (bao gồm nhưng
            không giới hạn ở các đại lý, bên cung cấp, nhà thầu, đối tác và bất kỳ người nào khác
            cung cấp dịch vụ cho Chúng Tôi là các đơn vị thu thập thông tin cá nhân của Bạn và/hoặc
            thực hiện các chức năng thay mặt Chúng Tôi hoặc với người mà Chúng Tôi cộng tác, bao gồm
            nhưng không giới hạn đối với các bên cung cấp dịch vụ thanh toán, các nguồn dữ liệu của
            chính phủ, các bên cung cấp dịch vụ tài chính, các tổ chức tín dụng, các đối tác cung
            cấp dịch vụ phân phối, dịch vụ giao hàng, tiếp thị và các dịch vụ khác), các bên liên
            kết của Chúng Tôi hoặc dữ liệu đó có thể được thu thập tự động khi Bạn sử dụng Ứng Dụng,
            như được trình bày trong phần này. Xem thêm mục 11.3 bên dưới về thu thập dữ liệu máy
            tính.
          </p>
          <p>
            2.5. Trong trường hợp Chúng Tôi thu thập dữ liệu cá nhân thông qua các bên thứ ba
            và/hoặc các bên liên kết của Chúng Tôi, Chúng Tôi sẽ chỉ thu thập dữ liệu cá nhân của
            Bạn khi được pháp luật cho phép hoặc liên quan đến các mục đích mà các bên thứ ba
            và/hoặc các bên liên kết của Chúng Tôi đã tiến hành, cho mục đích cộng tác của Chúng Tôi
            với các bên thứ ba và/hoặc các bên liên kết hoặc theo yêu cầu xác thực hoặc thẩm định
            nhận dạng. Trong quá trình Bạn sử dụng Ứng Dụng, Bạn xác nhận rằng Bạn đã đồng ý (dù là
            với chúng tôi, bên thứ ba hoặc các bên liên kết của Chúng Tôi) về việc chuyển dữ liệu cá
            nhân của Bạn từ bên thứ ba và/hoặc các bên liên kết của Chúng Tôi cho các mục đích được
            nêu trong Chính Sách này hoặc bất kỳ điều khoản nào khác.
          </p>
          <p>
            2.6. Bạn phải gửi dữ liệu cá nhân chính xác và không gây hiểu lầm, đồng thời Bạn phải
            cập nhật và thông báo cho Chúng Tôi về bất kỳ thay đổi nào đối với dữ liệu cá nhân mà
            Bạn đã cung cấp cho Chúng Tôi. Chúng Tôi sẽ có quyền yêu cầu cung cấp tài liệu và thực
            hiện việc kiểm tra cần thiết để xác minh dữ liệu cá nhân do Bạn cung cấp như một phần
            của quy trình xác minh người dùng của Chúng Tôi hoặc theo quy định của pháp luật.
          </p>
          <p>
            2.7. Chúng Tôi sẽ chỉ có thể thu thập một số danh mục dữ liệu cá nhân nhất định nếu Bạn
            tự nguyện cung cấp dữ liệu cá nhân đó cho Chúng Tôi hoặc theo cách khác được quy định
            theo Chính Sách này. Nếu Bạn chọn không cung cấp dữ liệu cá nhân của Bạn cho Chúng Tôi
            hoặc sau đó rút lại sự đồng ý của Bạn đối với việc Chúng Tôi sử dụng dữ liệu cá nhân của
            Bạn, Chúng Tôi có thể sẽ không cung cấp cho Bạn các tính năng hoặc chức năng nhất định
            trên Ứng Dụng.
          </p>
          <p>
            2.8. Nếu Bạn cung cấp dữ liệu cá nhân của bất kỳ bên thứ ba nào cho Chúng Tôi, Bạn cam
            đoan và đảm bảo rằng Bạn có được sự đồng ý, được cấp phép và được sự cho phép từ bên thứ
            ba đó để chia sẻ và chuyển dữ liệu cá nhân của họ cho Chúng Tôi, và để Chúng Tôi thu
            thập, lưu trữ, sử dụng và tiết lộ dữ liệu đó theo Chính Sách này.
          </p>
          <p>
            2.9. Nếu Bạn đăng ký trở thành người dùng trên Ứng Dụng của Chúng Tôi bằng tài khoản
            mạng xã hội của Bạn hoặc liên kết tài khoản trên Ứng Dụng với tài khoản mạng xã hội của
            Bạn, Chúng Tôi có thể truy cập dữ liệu cá nhân về Bạn mà Bạn đã tự nguyện cung cấp cho
            bên cung cấp dịch vụ mạng xã hội của Chúng Tôi phù hợp với các chính sách của bên cung
            cấp dịch vụ đó và Chúng Tôi sẽ quản lý dữ liệu cá nhân của Bạn phù hợp với Chính Sách
            này.
          </p>
        </section>

        {/* Section 3 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            3. MỤC ĐÍCH THU THẬP THÔNG TIN CÁ NHÂN
          </h2>
          <p>
            3.1. Dữ liệu cá nhân mà Chúng Tôi thu thập (như quy định tại mục 2 trên đây) từ Bạn hoặc
            thông qua các bên thứ ba có thể được Chúng Tôi sử dụng cho các mục đích sau:
          </p>

          <div className="space-y-4">
            {/* 3.1 (i) */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <p className="font-bold text-gray-900 mb-2">
                (i) Xử lý các yêu cầu mà Bạn thao tác trên Ứng Dụng
              </p>
              <ul className="legal-list text-sm list-disc pl-5 space-y-1">
                <li>Để xử lý các yêu cầu, thao tác mà Bạn thực hiện qua Ứng Dụng;</li>
                <li>
                  Chúng Tôi có thể chuyển thông tin của Bạn cho một bên thứ ba (ví dụ các bên cung
                  ứng dịch vụ cho Chúng Tôi, bên liên kết thanh toán trên Ứng Dụng) hoặc cơ quan có
                  thẩm quyền để cung ứng dịch vụ cho Bạn;
                </li>
                <li>Để cập nhật cho Bạn về tình trạng cung ứng dịch vụ;</li>
                <li>Để cung cấp các dịch vụ hỗ trợ khách hàng cho Bạn; và</li>
                <li>
                  Để xác minh và thực hiện các giao dịch thanh toán (bao gồm mọi khoản thanh toán
                  bằng thẻ tín dụng, chuyển khoản ngân hàng, thanh toán tiền mặt, chuyển tiền hoặc
                  giao dịch ví điện tử) liên quan đến các khoản thanh toán của Bạn. Để xác minh và
                  thực hiện các giao dịch thanh toán đó, thông tin thanh toán, có thể bao gồm dữ
                  liệu cá nhân, sẽ được chuyển cho bên thứ ba, chẳng hạn như bên cung cấp dịch vụ
                  thanh toán của Chúng Tôi.
                </li>
              </ul>
            </div>

            {/* 3.1 (ii) */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <p className="font-bold text-gray-900 mb-2">
                (ii) Cung ứng các dịch vụ được Bạn yêu cầu trên Ứng Dụng
              </p>
              <ul className="legal-list text-sm list-disc pl-5 space-y-1">
                <li>Để hỗ trợ Bạn sử dụng các dịch vụ hoặc truy cập vào Ứng Dụng;</li>
                <li>Để quản lý tài khoản của Bạn (nếu có) trên Ứng Dụng;</li>
                <li>
                  Để hiển thị tên, tên người dùng hoặc hồ sơ của Bạn trên Ứng Dụng (bao gồm những
                  lượt xem mà Bạn thực hiện);
                </li>
                <li>Để hỗ trợ việc sử dụng các ứng dụng mini-app có sẵn trên Ứng Dụng (nếu có);</li>
                <li>
                  Để trả lời các thắc mắc, phản hồi, khiếu nại hoặc tranh chấp của Bạn, dù trực tiếp
                  hay thông qua các bên cung cấp dịch vụ thứ ba của Chúng Tôi;
                </li>
                <li>
                  Để hiển thị trên bảng điểm trên Ứng Dụng liên quan đến các chiến dịch, trò chơi
                  trên thiết bị di động hoặc bất kỳ hoạt động nào khác (nếu có);
                </li>
                <li>
                  Để đánh giá đơn đăng ký của Bạn đối với các khoản vay và/hoặc để đánh giá rủi ro
                  tín dụng đối với hồ sơ đăng ký các dịch vụ tài chính (trong trường hợp áp dụng);
                  và
                </li>
                <li>
                  Để hỗ trợ tích hợp các chương trình khách hàng thân thiết của bên thứ ba với Ứng
                  Dụng của Chúng Tôi.
                </li>
              </ul>
            </div>

            {/* 3.1 (iii) */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <p className="font-bold text-gray-900 mb-2">(iii) Tiếp thị và quảng cáo</p>
              <ul className="legal-list text-sm list-disc pl-5 space-y-1">
                <li>
                  Để cung cấp cho Bạn thông tin mà Chúng Tôi cho rằng Bạn có thể thấy hữu ích hoặc
                  những thông tin Bạn đã yêu cầu từ Chúng Tôi (với điều kiện là Bạn đã chọn nhận
                  thông tin đó);
                </li>
                <li>
                  Gửi đến Bạn các thông tin tiếp thị hoặc khuyến mại về các sản phẩm và dịch vụ của
                  chúng Tôi trên Ứng Dụng theo từng thời điểm (với điều kiện là Bạn đã chọn nhận
                  thông tin đó);
                </li>
                <li>Để giúp Chúng Tôi thực hiện tiếp thị và quảng cáo; và</li>
                <li>
                  Để quảng bá các dịch vụ và sử dụng thông tin mà Bạn cung cấp cho Chúng Tôi, chẳng
                  hạn như nội dung do người dùng tạo ra (bao gồm cả nội dung video) mà Bạn chọn đăng
                  tải hoặc phát đi trên Ứng Dụng của Chúng Tôi và sẽ có thể truy cập được trên
                  Internet và có thể được chia sẻ bởi công chúng (mà các hoạt động truy cập và chia
                  sẻ đó không nằm trong tầm kiểm soát của Chúng Tôi), như một phần trong các chiến
                  dịch quảng cáo và tiếp thị của Chúng Tôi để quảng bá Ứng Dụng.
                </li>
              </ul>
            </div>

            {/* 3.1 (iv) */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <p className="font-bold text-gray-900 mb-2">(iv) Mục đích pháp lý và vận hành</p>
              <ul className="legal-list text-sm list-disc pl-5 space-y-1">
                <li>Để xác định danh tính của Bạn liên quan đến mục đích phát hiện gian lận;</li>
                <li>
                  So sánh thông tin, và xác minh với bên thứ ba để đảm bảo rằng thông tin là chính
                  xác;
                </li>
                <li>
                  Để xử lý mọi khiếu nại, phản hồi, hành động thực thi pháp luật và yêu cầu tháo gỡ
                  đối với bất kỳ nội dung nào Bạn đã tải lên Ứng Dụng;
                </li>
                <li>
                  Để thống kê và nghiên cứu cho các yêu cầu báo cáo nội bộ và báo cáo theo yêu cầu
                  pháp luật và/hoặc yêu cầu lưu trữ hồ sơ;
                </li>
                <li>Lưu trữ, lưu giữ trên máy chủ, sao lưu dữ liệu cá nhân của Bạn;</li>
                <li>
                  Để ngăn chặn hoặc điều tra bất kỳ hành vi vi phạm thực tế hoặc nghi ngờ vi phạm
                  nào đối với Điều Khoản Sử Dụng, Chính Sách của Chúng Tôi, gian lận, hoạt động bất
                  hợp pháp, thiếu sót hoặc hành vi sai trái, cho dù liên quan đến việc Bạn sử dụng
                  Ứng Dụng của Chúng Tôi hay bất kỳ vấn đề nào khác phát sinh từ mối quan hệ của Bạn
                  với Chúng Tôi;
                </li>
                <li>Để thực hiện việc kiểm tra thẩm định;</li>
                <li>
                  Để tuân thủ các yêu cầu pháp lý và của cơ quan quản lý (bao gồm, khi được áp dụng,
                  hiển thị tên, thông tin liên hệ của Bạn và thông tin công ty), bao gồm bất kỳ yêu
                  cầu thực thi pháp luật nào liên quan đến bất kỳ thủ tục pháp lý nào hoặc trong
                  trường hợp Chúng Tôi cho là cần thiết; và
                </li>
                <li>
                  Trong trường hợp cần thiết, để ngăn chặn mối đe dọa đến tính mạng, sức khỏe hoặc
                  sự an toàn.
                </li>
              </ul>
            </div>

            {/* 3.1 (v) */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <p className="font-bold text-gray-900 mb-2">
                (v) Phân tích, nghiên cứu, hoạt động kinh doanh và phát triển
              </p>
              <ul className="legal-list text-sm list-disc pl-5 space-y-1">
                <li>
                  Để hiểu trải nghiệm người dùng của Bạn đối với dịch vụ và Ứng Dụng của Chúng Tôi;
                </li>
                <li>
                  Để cải thiện bố cục hoặc nội dung của các trang thuộc Ứng Dụng và tùy chỉnh các bố
                  cục hoặc nội dung đó cho người dùng;
                </li>
                <li>Để xác định khách truy cập trên Ứng Dụng</li>
                <li>
                  Thực hiện các cuộc khảo sát, bao gồm thực hiện nghiên cứu về nhân khẩu học và hành
                  vi của người dùng của Chúng Tôi;
                </li>
                <li>
                  Để cải tiến công nghệ hiện tại của Chúng Tôi (ví dụ: công nghệ nhận dạng giọng
                  nói, v.v.) thông qua công nghệ máy móc và các phương tiện khác;
                </li>
                <li>
                  Để thu thập thêm các thuộc tính liên quan đến Bạn dựa trên dữ liệu cá nhân do Bạn
                  cung cấp (cho dù là cho Chúng Tôi hay bên thứ ba), nhằm cung cấp cho Bạn nhiều
                  thông tin đúng mục tiêu và/hoặc có liên quan hơn;
                </li>
                <li>
                  Để tiến hành phân tích dữ liệu, thử nghiệm và nghiên cứu, giám sát và phân tích xu
                  hướng sử dụng và hoạt động;
                </li>
                <li>Để phát triển nâng cấp các sản phẩm và dịch vụ của Chúng Tôi; và</li>
                <li>Để hiểu người dùng tốt hơn.</li>
              </ul>
            </div>

            {/* 3.1 (vi) */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <p className="font-bold text-gray-900 mb-2">(vi) Các vấn đề khác</p>
              <ul className="legal-list text-sm list-disc pl-5 space-y-1">
                <li>Bất kỳ mục đích nào khác đã được sự đồng ý của Bạn; và</li>
                <li>
                  Để tiến hành các quy trình ra quyết định tự động phù hợp với bất kỳ mục đích nào ở
                  trên.
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 4 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            4. PHẠM VI SỬ DỤNG THÔNG TIN VÀ CÁCH THỨC THU THẬP, KIỂM SOÁT, XỬ LÝ THÔNG TIN CÁ NHÂN
            CỦA BẠN
          </h2>
          <p>
            4.1. Dữ liệu cá nhân mà Chúng Tôi thu thập sẽ được sử dụng trong nước hoặc chuyển ra
            nước ngoài để phục vụ các mục đích được trình bày tại Chính Sách này.
          </p>
          <p>
            4.2. Dữ liệu cá nhân của Bạn sẽ được Chúng Tôi thu thập, kiểm soát và/hoặc xử lý thông
            qua Ứng Dụng, thông tin trên hợp đồng hoặc các văn bản, tài liệu có liên quan. Ngoài ra,
            Chúng Tôi có thể nhận được dữ liệu cá nhân của Bạn từ các đơn vị thành viên, đối tác,
            nhà cung cấp dịch vụ khác khi Bạn chấp thuận cung cấp thông tin cá nhân cho Chúng Tôi
            hay từ cơ quan hành chính công và các tổ chức chính phủ.
          </p>
          <p>
            4.3. Chúng tôi cam kết rằng việc thu thập, lưu trữ, xử lý thông tin cá nhân của Bạn
            thông qua Google Workspace APIs sẽ không nhằm mục đích phát triển, cải tiến, hoặc đào
            tạo các mô hình AI và/hoặc ML tổng quát (Generalized AI/ML models).
          </p>
        </section>

        {/* Section 5 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            5. THỜI GIAN LƯU TRỮ THÔNG TIN
          </h2>
          <p>
            5.1. Chúng Tôi sẽ chỉ lưu giữ dữ liệu cá nhân của Bạn khi được pháp luật cho phép, hoặc
            có liên quan đến các mục đích mà dữ liệu đó được thu thập.
          </p>
          <p>
            5.2. Chúng Tôi sẽ ngừng lưu giữ dữ liệu cá nhân của Bạn, hoặc loại bỏ phương tiện mà dữ
            liệu có thể được liên kết với Bạn ngay khi có lý do hợp lý cho thấy việc lưu giữ đó
            không còn phục vụ cho các mục đích mà dữ liệu cá nhân được thu thập và không còn cần
            thiết cho bất kỳ mục đích pháp lý hoặc kinh doanh nào.
          </p>
          <p>
            5.3. Không ảnh hưởng đến các điều khoản và điều kiện khác được cung cấp tại đây, dữ liệu
            cá nhân của Bạn sẽ được lưu trữ cho đến khi Bạn có yêu cầu xóa dữ liệu cá nhân và/hoặc
            hủy kích hoạt tài khoản người dùng của Bạn trên Ứng Dụng.
          </p>
        </section>

        {/* Section 6 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            6. NHỮNG NGƯỜI HOẶC TỔ CHỨC CÓ THỂ ĐƯỢC TIẾP CẬN VỚI THÔNG TIN
          </h2>
          <p>
            6.1. Tại Việt Nam, pháp nhân kiểm soát dữ liệu cá nhân của Bạn là CÔNG TY CỔ PHẦN ALPHA
            SPACEZ (tên tiếng Anh: ALPHA SPACEZ JOINT STOCK) – chủ sở hữu của Ứng Dụng.
          </p>
          <p>
            6.2. Chúng Tôi có thể chia sẻ (hoặc cho phép chia sẻ) dữ liệu cá nhân của Bạn và/hoặc
            chuyển giao dữ liệu cá nhân của Bạn cho các bên thứ ba và/hoặc các bên liên kết của
            chúng tôi cho mục đích sử dụng được đề cập tại Chính Sách này. Các bên thứ ba và bên
            liên kết có thể hiện diện trong hoặc ngoài Việt Nam, bao gồm nhưng không giới hạn ở:
          </p>
          <p className="pl-4 md:pl-8 italic text-gray-700">
            (i) Các bên cung cấp dịch vụ và các công ty liên quan của họ (ví dụ: đại lý, nhà thầu và
            đối tác trong các lĩnh vực như dịch vụ thanh toán, dịch vụ vận chuyển và giao nhận, tiếp
            thị, phân tích dữ liệu hoặc nghiên cứu khảo sát khách hàng, truyền thông xã hội, dịch vụ
            khách hàng, dịch vụ cài đặt, công nghệ thông tin và, dịch vụ lưu trữ web.
          </p>
          <p>
            6.3. Khi tiết lộ dữ liệu cá nhân của Bạn cho bên thứ ba, Chúng Tôi đảm bảo rằng các bên
            thứ ba và các bên liên kết của Chúng Tôi sẽ bảo mật dữ liệu cá nhân của Bạn khỏi các
            hành vi truy cập, thu thập, sử dụng, tiết lộ, xử lý thông tin dữ liệu trái phép hoặc các
            rủi ro tương tự và chỉ lưu giữ dữ liệu cá nhân của Bạn trong thời hạn cần thiết để đạt
            được các mục đích được đề cập ở trên.
          </p>
          <p>
            6.4. Chúng Tôi cũng có thể chia sẻ dữ liệu cá nhân liên quan đến bất kỳ giao dịch mua,
            sáp nhập hoặc mua lại nào trong hoạt động kinh doanh của Chúng Tôi, miễn là Chúng Tôi
            đáp ứng các quy định của luật bảo vệ dữ liệu hiện hành khi tiết lộ dữ liệu cá nhân của
            Bạn.
          </p>
          <p>
            6.5. Chúng Tôi có thể truyền tải hoặc cho phép chuyển dữ liệu cá nhân của Bạn ra ngoài
            Việt Nam cho bất kỳ mục đích nào được quy định trong Chính Sách này. Tuy nhiên, Chúng
            Tôi sẽ không chuyển hoặc cho phép bất kỳ dữ liệu cá nhân nào của Bạn được chuyển ra
            ngoài Việt Nam trừ khi việc chuyển dữ liệu cá nhân tuân thủ theo quy định của pháp luật
            hiện hành.
          </p>
          <p>
            6.6. Chúng Tôi có thể chia sẻ dữ liệu cá nhân của Bạn với các bên cung cấp dịch vụ thứ
            ba hoặc các bên liên kết của Chúng Tôi (ví dụ: bên cung cấp dịch vụ thanh toán) để họ
            cung cấp dịch vụ cho Bạn ngoài những dịch vụ được Bạn sử dụng trên Ứng Dụng. Việc Bạn
            đồng ý và sử dụng dịch vụ của bên cung cấp dịch vụ thứ ba hoặc của các bên liên kết của
            Chúng Tôi sẽ tuân thủ theo các điều khoản và điều kiện được thỏa thuận giữa Bạn và bên
            cung cấp dịch vụ thứ ba hoặc bên liên kết của Chúng Tôi. Khi Bạn đồng ý việc cung cấp
            dịch vụ của bên cung cấp dịch vụ thứ ba hoặc bên liên kết của Chúng Tôi, việc thu thập,
            sử dụng, tiết lộ, lưu trữ, chuyển giao và xử lý dữ liệu cá nhân của Bạn (bao gồm dữ liệu
            cá nhân của Bạn và bất kỳ dữ liệu nào được chúng tôi tiết lộ cho bên cung cấp dịch vụ
            thứ ba hoặc bên liên kết) sẽ phải tuân theo chính sách bảo mật hiện hành của bên cung
            cấp dịch vụ thứ ba hoặc bên liên kết của Chúng Tôi, các đơn vị này sẽ là người kiểm soát
            dữ liệu đã cung cấp. Bạn đồng ý rằng mọi thắc mắc hoặc khiếu nại liên quan đến việc Bạn
            đồng ý và sử dụng các dịch vụ của bên cung cấp dịch vụ thứ ba hoặc bên liên kết của
            Chúng Tôi sẽ được chuyển đến chính bên cung cấp dịch vụ thứ ba hoặc bên liên kết đó.
          </p>
        </section>

        {/* Section 7 */}
        <section className="mb-8 p-6 bg-blue-50 border border-blue-200 rounded-xl">
          <h2 className="text-xl font-bold text-blue-900 mb-4 uppercase">
            7. ĐỊA CHỈ CỦA ĐƠN VỊ THU THẬP VÀ QUẢN LÝ THÔNG TIN, BAO GỒM CÁCH THỨC LIÊN LẠC ĐỂ NGƯỜI
            TIÊU DÙNG CÓ THỂ HỎI VỀ HOẠT ĐỘNG THU THẬP, XỬ LÝ THÔNG TIN LIÊN QUAN ĐẾN CÁ NHÂN MÌNH
          </h2>
          <p>
            Nếu Bạn có bất kỳ thắc mắc hoặc khiếu nại nào về Chính Sách này hoặc về cách thức Chúng
            Tôi xử lý dữ liệu cá nhân của Bạn, vui lòng liên hệ với Chúng Tôi qua chức năng trò
            chuyện trực tuyến của Chúng Tôi được tích hợp trên Ứng Dụng hoặc theo các thông tin liên
            hệ sau:
          </p>

          <div className="mt-4 pl-4 border-l-4 border-blue-500">
            <p className="font-bold text-lg">Công ty Cổ Phần ALPHA SPACEZ</p>
            <p className="mt-2">
              <strong>Địa chỉ:</strong> 210 Bùi Văn Ba, Phường Tân Thuận, Thành phố Hồ Chí Minh,
              Việt Nam
            </p>
            <p>
              <strong>Số điện thoại:</strong>{" "}
              <a href="tel:0779827236" className="text-blue-600 hover:underline">
                0779827236
              </a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@zzp.vn" className="text-blue-600 hover:underline">
                support@zzp.vn
              </a>
            </p>
          </div>
        </section>

        {/* Section 8 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            8. PHƯƠNG THỨC VÀ CÔNG CỤ ĐỂ NGƯỜI TIÊU DÙNG TIẾP CẬN VÀ CHỈNH SỬA DỮ LIỆU CÁ NHÂN CỦA
            MÌNH TRÊN HỆ THỐNG THƯƠNG MẠI ĐIỆN TỬ CỦA ĐƠN VỊ THU THẬP THÔNG TIN
          </h2>
          <p>
            8.1. Để Bạn tiếp tục sử dụng Ứng Dụng và để Chúng Tôi cung ứng các dịch vụ, việc dữ liệu
            cá nhân của Bạn cung cấp cho Chúng Tôi phải chính xác và đầy đủ. Bạn có trách nhiệm
            thông báo cho Chúng Tôi về những thay đổi đối với dữ liệu cá nhân của Bạn, hoặc trong
            trường hợp Bạn tin rằng dữ liệu cá nhân mà Chúng Tôi thu thập về Bạn là không chính xác,
            không đầy đủ, gây hiểu lầm hoặc chưa cập nhật.
          </p>
          <p>
            8.2. Bạn có thể cập nhật dữ liệu cá nhân của mình bất kỳ lúc nào bằng cách truy cập vào
            tài khoản của Bạn trên Ứng Dụng.
          </p>
          <p>
            8.3. Chúng Tôi thực hiện các bước để chia sẻ các cập nhật dữ liệu cá nhân của Bạn với
            các bên thứ ba và các bên liên kết của chúng tôi nếu dữ liệu cá nhân của Bạn vẫn cần
            thiết cho các mục đích được quy định ở trên.
          </p>
          <p>
            8.4. Bạn có thể yêu cầu thông tin về dữ liệu cá nhân của Bạn mà Chúng Tôi đã thu thập
            hoặc hỏi về cách thức mà dữ liệu cá nhân của Bạn có thể đã được Chúng Tôi sử dụng, tiết
            lộ, lưu trữ hoặc xử lý bằng cách liên hệ với Chúng Tôi. Bạn cũng có thể yêu cầu sửa bất
            kỳ lỗi hoặc thiếu sót nào trong dữ liệu cá nhân của Bạn mà Chúng Tôi đã thu thập theo
            cách thức tương tự. Để hỗ trợ việc xử lý yêu cầu của Bạn, Chúng Tôi có thể cần yêu cầu
            Bạn cung cấp thêm thông tin về yêu cầu của Bạn. Trong trường hợp pháp luật cho phép,
            Chúng Tôi có thể từ chối thực hiện các yêu cầu sửa đổi của Bạn nếu những yêu cầu này là
            khó thực hiện hoặc không hợp lý.
          </p>
          <p>
            8.5. Trong trường hợp được pháp luật bảo vệ dữ liệu hiện hành cho phép, Chúng Tôi bảo
            lưu quyền tính phí hành chính hợp lý cho việc truy xuất hồ sơ dữ liệu cá nhân của Bạn.
            Trong trường hợp này, Chúng Tôi sẽ thông báo cho Bạn mức phí trước khi xử lý yêu cầu của
            Bạn.
          </p>
        </section>

        {/* Section 9 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            9. CAM KẾT BẢO MẬT THÔNG TIN CÁ NHÂN
          </h2>
          <p>
            9.1. Để bảo vệ dữ liệu cá nhân của Bạn khỏi các hành vi vi phạm pháp luật như truy cập,
            thu thập, sử dụng, tiết lộ, xử lý, sao chép, sửa đổi, sắp xếp, mất mát, sử dụng sai mục
            đích, chỉnh sửa mà không được sự cho phép của Bạn hoặc các rủi ro tương tự, chúng tôi đã
            đưa ra các biện pháp quản trị, biện pháp xử lý thực tế và biện pháp kỹ thuật thích hợp
            như sau:
          </p>
          <div className="pl-4 md:pl-8 mb-4 text-gray-700">
            <p>
              (a) Giới hạn quyền truy cập vào dữ liệu cá nhân đối với những cá nhân yêu cầu quyền
              truy cập;
            </p>
            <p>(b) Bảo trì các sản phẩm công nghệ để ngăn chặn truy cập trái phép vào máy tính;</p>
            <p>
              (c) Sử dụng công nghệ mã hóa 128-bit SSL (các lớp bảo mật) khi xử lý thông tin tài
              chính của Bạn; và/hoặc /
            </p>
            <p>(d) Thực hiện các biện pháp bảo mật khác theo yêu cầu của pháp luật hiện hành.</p>
          </div>
          <p>
            9.2. Tuy nhiên, Bạn nên hiểu rằng không có phương thức truyền tải nào qua Internet hoặc
            phương thức lưu trữ điện tử là an toàn tuyệt đối. Mặc dù việc bảo mật không thể đảm bảo
            tuyệt đối, nhưng Chúng Tôi nỗ lực để bảo vệ an toàn thông tin của Bạn và liên tục rà
            soát và nâng cấp các biện pháp bảo mật thông tin của Chúng Tôi.
          </p>
          <p>
            9.3. Ứng Dụng có thể chứa các liên kết đến các trang web khác do các bên khác vận hành,
            chẳng hạn như các bên liên kết kinh doanh hoặc cổng thanh toán của Chúng Tôi. Chúng Tôi
            không chịu trách nhiệm về thực tiễn bảo mật của các trang web do các bên này vận hành.
            Bạn nên thận trọng kiểm tra các chính sách bảo mật hiện hành của các trang web đó để xác
            định cách họ sẽ xử lý thông tin mà họ thu thập được từ Bạn.
          </p>
        </section>

        {/* Section 10 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            10. CƠ CHẾ TIẾP NHẬN VÀ GIẢI QUYẾT KHIẾU NẠI CỦA NGƯỜI TIÊU DÙNG LIÊN QUAN ĐẾN VIỆC
            THÔNG TIN CÁ NHÂN BỊ SỬ DỤNG SAI MỤC ĐÍCH HOẶC PHẠM VI ĐÃ THÔNG BÁO
          </h2>
          <p>
            10.1. Nếu Bạn nghi ngờ rằng dữ liệu cá nhân của Bạn đã bị sử dụng sai mục đích thu thập
            hoặc phạm vi sử dụng mà Chúng Tôi đã thông báo, Bạn có thể gửi thắc mắc hoặc khiếu nại
            nào về cách thức Chúng Tôi sử dụng dữ liệu cá nhân của Bạn qua chức năng trò chuyện trực
            tuyến của Chúng Tôi được tích hợp trên Ứng Dụng hoặc theo các thông tin liên hệ của
            Chúng Tôi nêu tại mục 7.
          </p>
          <p>
            10.2. Nhân viên bảo vệ dữ liệu của Chúng Tôi sẽ tiếp nhận các khiếu nại của Bạn và tùy
            theo tính chất và mức độ của thắc mắc hoặc khiếu nại của Bạn, Chúng Tôi sẽ có những biện
            pháp cụ thể để giải quyết thắc mắc hoặc khiếu nại của Bạn.
          </p>
        </section>

        {/* Section 11 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            11. CÁC ĐIỀU KHOẢN KHÁC
          </h2>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">
            11.1. Rút lại chấp thuận tiếp tục sử dụng, tiết lộ, lưu trữ và/hoặc xử lý dữ liệu cá
            nhân
          </h3>
          <div className="pl-4 md:pl-8 mb-4 text-gray-700">
            <p>
              (a) Bạn có thể thông báo về việc rút lại sự chấp thuận của Bạn đối với việc tiếp tục
              sử dụng, tiết lộ, lưu trữ và/hoặc xử lý dữ liệu cá nhân của Bạn bằng cách liên hệ với
              Chúng Tôi theo các thông tin liên lạc tại mục 7, tùy thuộc vào các điều kiện và/hoặc
              giới hạn được áp dụng bởi pháp luật hoặc quy định được áp dụng.
            </p>
            <p>
              (b) Xin lưu ý rằng nếu Bạn thông báo rút lại sự chấp thuận của Bạn đối với việc Chúng
              Tôi sử dụng, tiết lộ, lưu trữ hoặc xử lý dữ liệu cá nhân của Bạn cho các mục đích và
              bằng cách thức như đã nêu ở trên hoặc thực hiện các quyền khác của Bạn theo pháp luật
              hiện hành, Chúng Tôi có thể sẽ không tiếp tục cung ứng các dịch vụ cho Bạn hoặc thực
              hiện bất kỳ hợp đồng nào mà chúng tôi đã giao kết với Bạn và chúng tôi sẽ không chịu
              trách nhiệm trong trường hợp Chúng Tôi không tiếp tục cấp quyền truy cập Ứng Dụng hoặc
              thực hiện hợp đồng của Chúng Tôi với Bạn. Các quyền hợp pháp và biện pháp khắc phục
              của Chúng Tôi được bảo lưu rõ ràng trong trường hợp này.
            </p>
            <p>
              (c) Bạn có thể hủy đăng ký nhận thông tin tiếp thị vào bất kỳ thời điểm nào tại phần
              cài đặt trong ứng dụng trên thiết bị di động của Chúng Tôi hoặc bằng cách sử dụng chức
              năng hủy đăng ký tại tài liệu tiếp thị điện tử. Chúng Tôi có thể sử dụng thông tin
              liên hệ của Bạn để gửi bản tin cập nhật từ Chúng Tôi và từ các công ty liên kết của
              Chúng Tôi.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">11.2. Đối tượng chưa thành niên</h3>
          <div className="pl-4 md:pl-8 mb-4 text-gray-700">
            <p>
              (a) Chúng Tôi không cung cấp dịch vụ cho đối tượng chưa thành niên (được xác định trên
              cơ sở luật áp dụng), cũng như không có ý định cấp quyền sử dụng Ứng Dụng cho đối tượng
              chưa thành niên. Chúng Tôi không cố ý thu thập bất kỳ dữ liệu cá nhân nào liên quan
              đến đối tượng chưa thành niên.
            </p>
            <p>
              (b) Bạn theo đây xác nhận và đảm bảo rằng Bạn ở độ tuổi thành niên và Bạn có khả năng
              hiểu và chấp nhận các điều khoản của Chính Sách này. Nếu Bạn là đối tượng chưa thành
              niên, Bạn chỉ được sử dụng Ứng Dụng của Chúng Tôi khi có sự tham gia của cha mẹ hoặc
              người giám hộ hợp pháp.
            </p>
            <p>
              (c) Với tư cách là cha mẹ hoặc người giám hộ hợp pháp, vui lòng không cho phép đối
              tượng chưa thành niên dưới sự giám hộ của Bạn gửi dữ liệu cá nhân đến Chúng Tôi. Trong
              trường hợp dữ liệu cá nhân đó của đối tượng chưa thành niên được tiết lộ cho Chúng
              Tôi, Bạn theo đây đồng ý với việc xử lý dữ liệu cá nhân của đối tượng chưa thành niên
              và chấp nhận và đồng ý chịu sự ràng buộc của Chính Sách này và chịu trách nhiệm về
              hành động của đối tượng chưa thành niên đó.
            </p>
            <p>
              (d) Chúng Tôi sẽ không chịu trách nhiệm về bất kỳ việc sử dụng trái phép các dịch vụ
              trên Ứng Dụng bởi chính bản thân Bạn, người dùng khác hành động thay mặt Bạn hoặc bất
              kỳ người dùng trái phép nào. Bạn có trách nhiệm đưa ra quyết định thể hiện đầy đủ nhận
              thức của mình về việc sử dụng các dịch vụ trên Ứng Dụng và thực hiện các bước cần
              thiết để ngăn chặn bất kỳ hành vi sử dụng trái phép các dịch vụ trên Ứng Dụng.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">11.3. Thu thập Dữ Liệu Thiết bị</h3>
          <div className="pl-4 md:pl-8 mb-4 text-gray-700">
            <p>
              (a) Chúng tôi hoặc các bên cung ứng dịch vụ được ủy quyền của Chúng Tôi có thể sử dụng
              cookie, tập tin web và các công nghệ tương tự liên quan đến việc Bạn sử dụng dịch vụ
              hoặc truy cập Ứng Dụng.
            </p>
            <p>
              (b) Khi Bạn truy cập Ứng Dụng thông qua máy tính, thiết bị di động, hoặc bất kỳ thiết
              bị nào khác với kết nối Internet, máy chủ của Chúng Tôi sẽ tự động ghi lại dữ liệu mà
              trình duyệt của Bạn gửi đi bất cứ khi nào Bạn truy cập một trang web, chẳng hạn như dữ
              liệu kỹ thuật và dữ liệu sử dụng được nêu trong mục 2.2 ở trên.
            </p>
            <p>
              (c) Dữ liệu này được thu thập để phân tích và đánh giá nhằm giúp Chúng Tôi cải thiện
              trang web/ ứng dụng của Chúng Tôi và các dịch vụ và sản phẩm mà Chúng Tôi cung cấp,
              cũng như giúp Chúng Tôi cá nhân hóa nội dung để phù hợp với sở thích ưu tiên của Bạn
              nhanh chóng hơn. Dữ liệu cũng được thu thập để làm cho các dịch vụ và Ứng Dụng trở nên
              thuận tiện và hữu ích hơn cho Bạn, đồng thời cung cấp quảng cáo phù hợp hơn liên quan
              đến các sản phẩm, dịch vụ và tính năng của thị trường cho Bạn.
            </p>
            <p>
              (d) Cookie là các tệp văn bản nhỏ (thường bao gồm các chữ cái và số) được đặt trong bộ
              nhớ của trình duyệt hoặc thiết bị của Bạn khi Bạn truy cập một trang web hoặc xem một
              tin nhắn. Chúng cho phép Chúng Tôi nhận ra một thiết bị hoặc trình duyệt cụ thể. Tập
              tin chỉ báo là những hình ảnh đồ họa nhỏ có thể được đưa vào các dịch vụ và Ứng Dụng
              của Chúng Tôi. Chúng cho phép Chúng Tôi đếm những người dùng đã xem các trang này để
              Chúng Tôi có thể hiểu rõ hơn về mối quan tâm và ưu tiên của Bạn.
            </p>
            <p>
              (e) Bạn có thể quản lý và xóa các cookie thông qua trình duyệt hoặc cài đặt thiết bị
              của Bạn. Tuy nhiên, một số cookie nhất định được yêu cầu phải có để kích hoạt tính
              năng căn bản (chẳng hạn như thêm các mặt hàng vào giỏ hàng của Bạn), vì vậy xin lưu ý
              rằng việc thay đổi và xóa cookie có thể ảnh hưởng đến tính năng có sẵn trên Ứng Dụng.
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}

export default PrivacyPage
